import { Box, ButtonNew, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Dimensions } from 'react-native'
import { htmlRouting } from '../../comps/Nav'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { styles } from './styles'
const ImageLanding = require('../../assets/images/partner/earn_share.png')
const ImageLandingMobile = require('../../assets/images/partner/earn_share_mobile.png')

const EarnAsYouShare: FC = () => {
  const { headerSize, textSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)

  

  const isMob = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)

  const onContactUsClicked = () => {
    htmlRouting(isMob ? 'becomePartnerForm' :'becomePartnerFormBottomDottedImage')
  }
  const returnImageStyle = () => {
    if (isMob) {
      return { ...imageStyle.portaitImageStyle }
    } else {
      return { ...imageStyle.wide }
    }
  }

  const returnImage = () => {
    if (isMob) {
      return ImageLandingMobile
    } else {
      return ImageLanding
    }
  }

  return (
    <Box {...themedStyle.content}>
      <Box {...themedStyle.boxLanding}>
        <Box>
          <Box flexDirection={'row'} align={'center'}>
            <Text
              fontFamily="jiotype-medium"
              fontSize={isMob ? 10 : 18}
              color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
              letterSpacing={isMob ? 3 : 3.6}
              lineHeight={isMob ? 16 : isTab ? 18 : 32}>
              {'JIOPAY BUSINESS PARTNER PROGRAM'}
            </Text>
            <Spacer direction="horizontal" size={16} />
            <Box h={'1'} bg={colors.JIO_PRIMARY_ALPHA as ColorOptions} w={isMob ? 10 : 48} />
          </Box>
          <Spacer direction={'vertical'} size={isMob ? 20 : 0} />
          <Text fontFamily="jiotype-black" fontSize={headerSize} lineHeight={isMob ? 32 : isTab ? 38 : 66}>
            {'Earn as you share'}
          </Text>
        </Box>
        <Spacer size={isMob ? 16 : 8} />
        <Box width={isMob ? '95%' : '75%'}>
          <Text
            color="BLACK_21"
            textAlign="left"
            lineHeight={isMob || isTab ? 24 : 30}
            fontSize={isMob ? 14 : isTab ? 14 : 18}
            fontFamily="jiotype-medium"
            opacity={0.9}>
            {staticStrings.partnerEarnShareSubTitle}
          </Text>
        </Box>
        <Spacer direction="vertical" size={8} />
        <Box {...themedStyle.buttonBox}>
          <ButtonNew
            {...themedStyle.button}
            onPress={onContactUsClicked}
            hoverColor={colors.HIGHLIGHT as ColorOptions}
            width={isMob ? 170 : 218}>
            <Text title={'Become a Partner'} fontFamily={'jiotype-bold'} color={'WHITE'} fontSize={14} />
          </ButtonNew>
        </Box>
        <Spacer direction="vertical" size={isMob ? 8 : 0} />
      </Box>
      <Box {...themedStyle.imageBox} {...themedStyle.imageBoxFix}>
        <Image resizeMode="contain" source={returnImage()} {...returnImageStyle()} />
      </Box>
    </Box>
  )
}

export default EarnAsYouShare
const width = Dimensions.get('window').width

const imageStyle = {
  portaitImageStyle: {
    height: '100%',
    width: width,
    left: 8,
  },
  wide: {
    width: 637,
    height: 637 * 0.72,
    top: 0,
    left: 40,
  },
}
